const { post, get, adminCall } = require("./_utils");

module.exports = {
  checkRegister: (params) => get("/auth/checkRegister", {params}),
  register: data => post("/register", {data}),
  validate: data => adminCall("registration.validate", data),
  remove: uid => adminCall("registration.remove", {uid})
}
